module.exports = __webpack_public_path__ + "static/media/logo192.66b005c9.png";